import { fuseFilter, nullOrUndefined } from '@/plugins/fuse'
import { SSharedList } from '@/services/shared'
import QUERY from 'lodash'

export default {
  data () {
    return {
      fetching: {
        locations: false
      },
      options: {
        locations: []
      },
      selected: {
        location: '',
        locationType: ''
      },
      editable: {
        location: ''
      }
    }
  },

  methods: {

    async getLocations (context, search = '') {
      const selectedContext = context?.selected
      const fetchingContext = context?.fetching
      const optionsContext = context?.options

      if (nullOrUndefined(selectedContext) || nullOrUndefined(fetchingContext) || nullOrUndefined(optionsContext)) {
        throw Error('Invalid context object')
      }

      const selected = context.selected?.location
      const fetching = context.fetching?.locations
      const options = context.options?.locations

      if (nullOrUndefined(selected) || nullOrUndefined(fetching) || nullOrUndefined(options)) {
        throw Error('Invalid context object')
      }

      context.fetching.locations = true
      context.selected.location = ''

      const filters = {
        filter_text: search,
        location_type: context.selected.locationType
      }

      return await SSharedList.getLocations(filters).then(
        ({ data }) => {
          context.options.locations = data
        }
      ).catch(() => {
        context.options.locations = []
      }).finally(() => {
        context.fetching.locations = false
      })
    },

    async searchLocations (search, loading) {
      this.searchLocationsProvider(this, search, loading)
    },

    searchLocationsProvider: QUERY.debounce(
      ({ options, selected }, search, loading) => {
        const filteredOptions = fuseFilter(search, options.locations, {
          keys: ['location_name']
        })

        if (filteredOptions.length < 1) {
          loading(true)

          const filters = {
            filter_text: search,
            location_type: selected.locationType
          }

          SSharedList.getLocations(filters).then(
            ({ data }) => {
              options.locations = data
            }
          ).catch(() => {
            options.locations = []
          }).finally(() => {
            loading(false)
          })
        }
      }, 500
    )
  }
}
